import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE =
  "Calculatrice en ligne du cercle - Rayon à partir du diamètre ou du périmètre";
const DESCRIPTION =
  "Calculatrice en ligne du cercle - Rayon à partir du diamètre ou du périmètre pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "du cercle rayon à partir du diamètre ou du périmètre, calculatrice du cercle rayon à partir du diamètre ou du périmètre, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/circle-radius";
function CircleRadiusCalculator() {
  const [diameter, setDiameter] = useState("");
  const [circumference, setCircumference] = useState("");
  const [area, setArea] = useState("");
  const [radius, setRadius] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    if (!diameter && !circumference && !area) {
      setError("Veuillez entrer le diamètre, le périmètre ou l'aire");
      setRadius("");
      return;
    }
    if (diameter) {
      const diameterValue = parseFloat(diameter);
      if (!isNaN(diameterValue) && diameterValue >= 0) {
        setRadius((diameterValue / 2).toFixed(2));
        setError("");
        return;
      }
    }
    if (circumference) {
      const circumferenceValue = parseFloat(circumference);
      if (!isNaN(circumferenceValue) && circumferenceValue >= 0) {
        setRadius((circumferenceValue / (2 * Math.PI)).toFixed(2));
        setError("");
        return;
      }
    }
    if (area) {
      const areaValue = parseFloat(area);
      if (!isNaN(areaValue) && areaValue >= 0) {
        setRadius(Math.sqrt(areaValue / Math.PI).toFixed(2));
        setError("");
        return;
      }
    }
    setError("Veuillez entrer des valeurs valides (diamètre, périmètre ou aire)");
    setRadius("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Utilisez cette calculatrice du cercle pour calculer et trouver
                  le périmètre, l'aire et le diamètre d'un cercle.
                </p>
                <h2 style={{ fontSize: "18px" }}>Qu'est-ce qu'un cercle ?</h2>
                <p>
                  Le cercle est une figure plane dont tous les points du bord sont
                  équidistants du centre. Les formules suivantes sont utilisées :
                  Aire du cercle A = π × r² et Périmètre C = 2 × π × r,
                  où π est la constante (environ 3,14159).
                </p>
                <h2 style={{ fontSize: "18px" }}>Comment calculer le rayon d'un cercle</h2>
                <p>
                  Cette calculatrice calcule le rayon du cercle à partir des données suivantes :
                </p>
                <ol>
                  <li>
                    Si le diamètre (d) est disponible, le rayon se calcule par :
                    <br />
                    Rayon = Diamètre / 2
                  </li>
                  <li>
                    Si le périmètre (C) est disponible, le rayon se calcule par :
                    <br />
                    Rayon = Périmètre / (2 × π)
                  </li>
                  <li>
                    Si l'aire (A) est disponible, le rayon se calcule par :
                    <br />
                    Rayon = √(Aire / π)
                  </li>
                </ol>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Diamètre (d)</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Si le diamètre est disponible"
                      value={diameter}
                      onChange={(e) => setDiameter(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Périmètre (C)</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Si le périmètre est disponible"
                      value={circumference}
                      onChange={(e) => setCircumference(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Aire (A)</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Si l'aire est disponible"
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    Calculer le rayon
                  </button>
                </div>
                <br />
                <div>
                  {error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      Erreur : {error}
                    </p>
                  ) : (
                    <>
                      {radius !== "" && (
                        <>
                          <p className="p-3 mb-2 bg-success text-white">
                            Rayon :
                          </p>
                          <p className="p-3 mb-2 bg-info text-black">
                            {radius} cm
                          </p>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default CircleRadiusCalculator;
